import type { FilterLocation } from "../types"

let location: FilterLocation = {
    slug: SearchConfig.location.slug,
    name: SearchConfig.location.name === "" ? "allen Regionen" : SearchConfig.location.name,
    cityId: SearchConfig.location.cityId,
    postalCodes: SearchConfig.location.postalCodes,
    locationType: SearchConfig.location.locationType,
    regionId: SearchConfig.location.regionId,
    plz: SearchConfig.location.plz,
    address: SearchConfig.location.address,
    addressName: SearchConfig.location.addressName,
}

export function setFilterLocation(newLocation: FilterLocation) {
    location = newLocation
}

export function getLocation() {
    return location
}

export function getLocationAsString() {
    return location.slug || ""
}
